/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatussentnone3Inputs */

const en_actionstatussentnone3 = /** @type {(inputs: Actionstatussentnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No favourites – no push sent`)
};

const de_actionstatussentnone3 = /** @type {(inputs: Actionstatussentnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Favoriten – keine Mitteilung verschickt`)
};

/**
* | output |
* | --- |
* | "No favourites – no push sent" |
*
* @param {Actionstatussentnone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatussentnone3 = /** @type {((inputs?: Actionstatussentnone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatussentnone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatussentnone3(inputs)
	return de_actionstatussentnone3(inputs)
});
export { actionstatussentnone3 as "actionStatusSentNone" }